<template>
  <div class="flow-service-table" v-loading="loading">
    <div class="tab-header">
      <span class="tab-title">平台服务费信息</span>
      <el-button type="primary" size="small" @click="openConfigDialog">配置服务费</el-button>
    </div>

    <div class="summary-cards">
      <div v-for="card in cardList" :key="card.title" class="summary-card"
        :class="{ 'date-range-card': card.isDateRange }">
        <div v-if="card.isDateRange" class="date-range-value">
          <div class="date-item">
            <div class="date-text">{{ card.startDate }}</div>
            <div class="time-text">{{ card.startTime }}</div>
          </div>
          <div class="arrow">&rarr;</div>
          <div class="date-item">
            <div class="date-text">{{ card.endDate }}</div>
            <div class="time-text">{{ card.endTime }}</div>
          </div>
        </div>
        <div v-else class="card-value">{{ card.value }}</div>
        <div class="card-title">{{ card.title }}</div>
      </div>
    </div>
    <el-table :data="tableData" border stripe style="width: 100%">
      <el-table-column prop="payWalletListId" label="支付流水号" width="280" />
      <el-table-column prop="payAmount" label="流量费价格（元）" width="150" />
      <el-table-column prop="activeStartDatetime" label="服务开始时间" width="200" />
      <el-table-column prop="expiryDatetime" label="服务到期时间" width="200" />
      <el-table-column prop="recordStatus" label="服务周期状态" width="200" />
      <el-table-column prop="payType" label="支付方式" width="100">
        <template slot-scope="scope">
          {{ getPayTypeText(scope.row.payType) }}
        </template>
      </el-table-column>
      <el-table-column prop="payDatetime" label="支付完成时间" width="200" />
      <el-table-column prop="createdWhen" label="账单创建时间" width="200" />
    </el-table>
    <el-pagination v-if="total > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 16px; text-align: right" />

    <!-- 配置服务费弹窗：与「小红书活动-去发放奖励」共用同一组件（../components/FeeConfigDialog.vue） -->
    <!-- 本页（平台服务费页签）不锁来源：配置类型可自由选「售后赠送 / 活动赠送」 -->
    <FeeConfigDialog
      :visible.sync="configDialogVisible"
      :user-name="userName"
      :user-mobile="userMobile"
      :activity-name="activityName"
      :unit-price="unitPrice"
      :submitting="submitting"
      @submit="submitConfig"
    />
  </div>
</template>

<script>
import FeeConfigDialog from '../components/FeeConfigDialog.vue';

export default {
  name: 'AnxinPackActivityFlowServiceTable',
  components: { FeeConfigDialog },
  props: {
    activityOrderId: { type: String, default: '' },
    activityOrderNo: { type: String, default: '' },
    userName: { type: String, default: '' },
    userMobile: { type: String, default: '' },
    activityName: { type: String, default: '' },
    activityType: { type: String, default: '' },
  },
  data() {
    return {
      flowInfo: {},
      tableData: [],
      loading: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      configDialogVisible: false,
      submitting: false,
    };
  },
  computed: {
    cardList() {
      const info = this.flowInfo || {};
      let dateRangeCard = { title: '当前服务周期', value: '暂无', isDateRange: false };
      if (info.startTime && info.endTime) {
        const [startDate, startTime] = info.startTime.split(' ');
        const [endDate, endTime] = info.endTime.split(' ');
        dateRangeCard = { title: '当前服务周期', isDateRange: true, startDate: startDate || '', startTime: startTime || '', endDate: endDate || '', endTime: endTime || '' };
      }
      return [
        { title: '累计使用月份', value: info.monthsOfUse || 0 },
        { title: '累计支付金额', value: `${info.accumulatedPayments || 0}元` },
        { title: '流量周期费用', value: `${info.chargingStandards || 0}元` },
        { title: '当前服务状态', value: this.getServiceStatusText(info.recordStatus) },
        dateRangeCard,
        { title: '当前服务剩余天数', value: info.daysRemaining ? `${info.daysRemaining}天` : '0天' },
      ];
    },
    unitPrice() {
      // 优先取后端流量统计接口返回的收费标准(chargingStandards);
      // 无值时按活动类型兜底: 698活动8元/月, 其余(598)默认5元/月
      const standard = Number(this.flowInfo && this.flowInfo.chargingStandards);
      if (!Number.isNaN(standard) && standard >= 0) return standard;
      const type = String(this.activityType || '');
      if (type.includes('698')) return 8;
      return 5;
    },
    totalGiftAmount() {
      const months = Number(this.configForm.giftMonths) || 0;
      return (months * this.unitPrice).toFixed(2);
    },
  },
  watch: {
    activityOrderId: {
      handler(newVal) {
        if (newVal) { this.fetchFlowServiceInfo(); this.fetchTableData(); }
      },
      immediate: true,
    },
    activityOrderNo: {
      handler(newVal) {
        if (newVal && !this.activityOrderId) this.fetchTableData();
      },
    },
  },
  methods: {
    openConfigDialog() {
      this.configDialogVisible = true;
    },
    /** 提交由弹窗组件校验后 emit（payload: { giftType, giftMonths }），本页负责落接口 */
    submitConfig(payload) {
      const _ = this;
      _.submitting = true;
      const submitData = {
        activityOrderNo: _.activityOrderNo,
        giftType: payload.giftType,
        giftMonths: payload.giftMonths,
      };
      _.$H
        .post(_, _.$A.giftTraffic.gift, submitData)
        .then((res) => {
          _.submitting = false;
          _.$U.success('配置成功');
          _.configDialogVisible = false;
          _.fetchFlowServiceInfo();
          _.fetchTableData();
          _.$emit('gift-success');
        })
        .catch(() => {
          _.submitting = false;
        });
    },
    fetchFlowServiceInfo() {
      if (!this.activityOrderId) return;
      this.loading = true;
      const params = {
        corpNo: this.$store?.state?.corpNo,
        activityOrderId: this.activityOrderId || '',
        activityType: this.activityType || '',
      };
      this.$H.post(this, this.$A.activityOrder.axbTrafficStatistics, params).then((res) => {
        if (res.data && res.data.status === 200) {
          this.flowInfo = res.data.data || {};
        } else {
          this.$message.error(res.data?.message || '获取流量服务信息失败');
        }
      }).catch(() => {
        this.$message.error('获取流量服务信息失败');
      }).finally(() => {
        this.loading = false;
      });
    },
    fetchTableData() {
      if (!this.activityOrderId) return;
      this.loading = true;
      const params = {
        corpNo: this.$store?.state?.corpNo,
        activityOrderNo: this.activityOrderNo || '',
        pageNum: this.pageNum - 1,
        pageSize: this.pageSize,
      };
      this.$H.post(this, this.$A.activityOrder.trafficStatisticsPage, params).then((res) => {
        if (res.data && res.data.status === 200) {
          const data = res.data.data || {};
          this.tableData = data.content || data.list || data.records || [];
          this.total = data.totalElements || data.total || 0;
        } else {
          this.$message.error(res.data?.message || '获取表格数据失败');
        }
      }).catch(() => {
        this.$message.error('获取表格数据失败');
      }).finally(() => {
        this.loading = false;
      });
    },
    handleSizeChange(val) { this.pageSize = val; this.pageNum = 1; this.fetchTableData(); },
    handleCurrentChange(val) { this.pageNum = val; this.fetchTableData(); },
    getServiceStatusText(status) {
      const statusMap = {
        COMMIT: '已报名',
        TO_SIGN: '待签约',
        IN_SIGN: '已签约',
        TO_INSTALL: '待安装',
        TO_ACTIVATION: '待激活',
        IN_USE: '使用中',
        TO_COMPLIANCE: '待守约',
        IN_OVERDUE: '已逾期',
        IN_DEFAULTED: '已违约',
        TO_RENEWED: '待续费',
        IN_CANCELING: '解约申请中',
        IN_CANCELLED_BUYOUT: '已解约(买断)',
        IN_CANCELLED_REFUNDED: '已解约(退出)',
        IN_CANCELLED_DEFAULTED: '已解约(违约)',
        IN_EXPIRED: '已解约(到期)',
        IN_CLOSE: '已退出',
        TO_RESET_SIGN: '待激活签约',
        PAUSE: '暂停使用',
        CANCELLED_NOT_INSTALL: '已解约(未安装退出)',
        BUYOUT_IN_USE_STATUS: '提前买断·使用中',
        HAVING_ERROR_ILLEGAL_BUYOUT: '已解约·违约买断',
        COMMON: '正常',
        ABOUT_TO_EXPIRE: '即将到期',
        TO_EXPRIRED: '即将到期',
        TO_EXPIRED: '即将到期',
        EXPIRED: '已到期',
        CANCELED: '已解约',
        EXPIRING_SOON: '即将到期',
        TO_ACTIVE: '待激活',
        ACTIVE: '正常',
        IN_ACTIVE: '正常',
        CANCELLED: '已解约（买断）',
      };
      return statusMap[status] || status || '未知';
    },
    getPayTypeText(payType) {
      const payTypeMap = {
        ALIPAY: '支付宝',
        MANTUAL_ALIPAY: '支付宝支付(手动支付)',
        SYSTEM_GIFT: '系统赠送',
        CYCLE_WITH_HOLD: '免密支付(支付宝代扣)',
        AFTER_SALE_GIFT: '售后赠送',
        ACTIVITY_GIFT: '活动赠送',
      };
      return payTypeMap[payType] || payType || '--';
    },
  },
};
</script>

<style scoped>
.flow-service-table {
  margin-top: 10px;
}

.tab-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.tab-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.summary-cards {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.summary-card {
  flex: 1;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.card-value {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 6px;
  white-space: nowrap;
}

.card-title {
  font-size: 16px;
  color: #6b7280;
}

.date-range-card {
  min-width: 280px;
}

.date-range-value {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 6px;
}

.date-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.date-text {
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
  white-space: nowrap;
}

.time-text {
  font-size: 13px;
  color: #6b7280;
  white-space: nowrap;
}

.arrow {
  font-size: 24px;
  color: #9ca3af;
  font-weight: bold;
  margin: 0 8px;
}
</style>
